import Vue from 'vue';
import VueRouter from "vue-router";

Vue.use(VueRouter);
Vue.use(require('vue-cookies'));

import Home from '../views/home.vue';
import Login from '../views/account/login.vue';
import Register from '../views/account/register.vue';
import ForgotPassword from '../views/account/forgot-password.vue';
import ResetPassword from '../views/account/reset-password.vue';

import PermissionCreate from '../views/permission/create.vue';
import PermissionList from '../views/permission/list.vue';
import PermissionUpdate from '../views/permission/update.vue';

import AdminCreate from '../views/admin-setting/create.vue';
import AdminUpdate from '../views/admin-setting/admin-update.vue';
import AdminList from '../views/admin-setting/list.vue';

import PinCreate from '../views/admin-setting/pin-create.vue';
import PinList from '../views/admin-setting/pin-list.vue';
import PinUpdate from '../views/admin-setting/pin-update.vue';

import RoleCreate from '../views/role/create.vue';
import RoleList from '../views/role/list.vue';
import RoleUpdate from '../views/role/update.vue';
import RoleUser from '../views/role/user-role.vue';

import MarkupCreate from '../views/markup-commision/create.vue';
import MarkupComList from '../views/markup-commision/list.vue';
import MarkupComUpdate from '../views/markup-commision/update.vue';

import AirlineCreate from '../views/airlines/create.vue';
import AirlineList from '../views/airlines/list.vue';
import AirlineUpdate from '../views/airlines/update.vue';

import AgentCreate from '../views/agent/create.vue';
import AgentList from '../views/agent/list.vue';
import UnverifiedAgentList from '../views/agent/unverified.vue';
import AgentUpdate from '../views/agent/update.vue';
import AgentApproval from '../views/agent/approval.vue';
import RejAgentList from '../views/agent/reject.vue';
import WhiteLabelAgentList from '../views/agent/while-label-agent';
import WhiteLabelAgentAssign from '../views/agent/white-label-assign';
import RoleAssignB2b from '../views/agent/role-assign-b2b.vue'

import SubAgentCreate from '../views/agent/sub-agent-create.vue';
import SubAgentList from '../views/agent/sub-agent-list.vue';

import APIvendorEntry from '../views/api-vendor/create.vue';
import APIVendorList from '../views/api-vendor/list.vue';
import APIVendorUpdate from '../views/api-vendor/update.vue';

import RoleAssign from '../views/admin-setting/role-assign.vue';
import PermissionAssign from '../views/admin-setting/permission-assign.vue';

import BlockList from '../views/airline-blocking/list.vue';
import BlockEntry from '../views/airline-blocking/create.vue';
import BlockUpdate from '../views/airline-blocking/update.vue';

import RouteList from '../views/airline-routing/list.vue';
import RouteEntry from '../views/airline-routing/create.vue';
import RouteUpdate from '../views/airline-routing/update.vue';

import SalesManagerList from '../views/sales-manager/list.vue';
import SalesManagerEntry from '../views/sales-manager/create.vue';
import SalesManagerUpdate from '../views/sales-manager/update.vue';
import SalesManagerAgent from '../views/sales-manager/sales-manager-agent.vue';

import ActivityList from '../views/activities/list.vue';
import ActivityEntry from '../views/activities/create.vue';
import ActivityUpdate from '../views/activities/update.vue';

import DepositList from '../views/deposit/list.vue';
import DepositBalance from '../views/deposit/deposit-balance.vue';
import DeductBalance from '../views/deposit/deduct-balance.vue';
import LoanBalance from '../views/deposit/loan-balance.vue';

import FlightBookingList from '../views/flight-booking/list.vue';
import FlightTicketInvoice from '../views/flight-booking/invoice.vue';
import FlightBookingDetails from '../views/flight-booking/details.vue';
import FlightBookingTicket from '../views/flight-booking/ticket.vue';
import FlightBookingUpdate from '../views/flight-booking/update.vue';
import FlightBookingCreate from '../views/flight-booking/create.vue';

import FlightTicketList from '../views/ticketing/list.vue';
import FlightTicketUpdate from'../views/ticketing/update.vue';


import FlightSalesReport from '../views/reports/flightSales.vue';
import ManagerBookingReport from '../views/reports/sales-manager-booking.vue';
import SearchBookRatioUser from '../views/ratio/user-search-book-ratio.vue';
import SearchBookRatioManager from '../views/ratio/manager-search-book-ratio.vue';

import LedegerList from '../views/ledger/list.vue';

import FlightSearchLog from '../views/flight-search-log/list.vue';

import SupportTicketSubjectList from '../views/support-ticket/subject-list.vue';
import SupportTicketList from '../views/support-ticket/ticket-list.vue';
import SupportTicketHistory from '../views/support-ticket/history.vue';
import CreateSupportTicket from '../views/support-ticket/create-ticket.vue'
import CreateSupportTicketSubject from '../views/support-ticket/subject-create.vue';
import UpdateSupportTicketSubject from '../views/support-ticket/subject-update.vue';

import B2cUserList from '../views/b2c-user/list.vue';
import B2cUserShow from '../views/b2c-user/show.vue';
import B2cUserUpdate from '../views/b2c-user/update.vue';
import B2cUserRole from '../views/b2c-user/role-assign-b2c.vue';
import B2cUserRoleList from '../views/b2c-user/b2c-user-role';

import HotelMarkupCreate from '../views/hotel-markup-commision/create.vue';
import HotelMarkupList from '../views/hotel-markup-commision/list.vue';
import HotelMarkupUpdate from '../views/hotel-markup-commision/update.vue';

import HotelRouteEntry from '../views/hotel-routing/create.vue';
import HotelRouteList from '../views/hotel-routing/list.vue';
import HotelRouteUpdate from '../views/hotel-routing/update.vue';

import HotelBlockEntry from '../views/hotel-blocking/create.vue';
import HotelBlockList from '../views/hotel-blocking/list.vue';
import HotelBlockUpdate from '../views/hotel-blocking/update.vue';

import HotelBookingList from '../views/hotel-booking/list.vue';
import HotelBookingUpdate from '../views/hotel-booking/update';

import HotelSalesReport from '../views/hotel-sales-report/list.vue';

import PartialPaymentList from '../views/partial-payment/list.vue';

import AgentUserDetails from '../views/agent/agent-user-details.vue';
import AdminAgentDetails from '../views/agent/admin-agent-details.vue';

import NotificationMailEntry from '../views/notification-mail/create.vue';
import NotificationMailList from '../views/notification-mail/list.vue';
import NotificationMailUpdate from '../views/notification-mail/update.vue';

import AirportEntry from '../views/airports/create.vue';
import AirportList from '../views/airports/list.vue';
import AirportUpdate from '../views/airports/update.vue';

import TransactionHistories from '../views/transaction-history/list.vue';
function guardMyroute(to, from, next) {

    var isAuthenticated = false;
    if (localStorage.getItem('LoggedUser') == 'LOGGED')
    {
        isAuthenticated = true;
        localStorage.setItem("last_route", to.path);
    }
    else
        isAuthenticated = false;

    if (isAuthenticated) {
        next(); // allow to enter route
    } else {
        next('/login'); // go to '/login';
        localStorage.setItem("last_route", '/dashboard');
    }
}

function loginCheck(to, from, next) {

    var isAuthenticated = false;
    if (localStorage.getItem('LoggedUser') === 'LOGGED' && from.path !== '/login')
        isAuthenticated = true;
    else
        isAuthenticated = false;

    if (isAuthenticated) {
        next('/dashboard');
    } else {
        if (to.path === '/login') {
            next();
        } else {
            next({
                path: '/login'
            });
        }

    }
}

function logout(to, from, next) {
    localStorage.setItem("LoggedUser", 'NL');
    next('/login'); // go to '/login';
}

const routes = new VueRouter({
    mode: 'hash',
    routes: [{
        path: '/',
        redirect: {
            name: "login"
        }
    },
    {
        path: '/dashboard',
        component: Home,
        beforeEnter: guardMyroute,
        meta: {
            title: 'Home'
        }
    },
    {
        path: '/login',
        name: "login",
        component: Login,
        beforeEnter: loginCheck,
        meta: {
            title: 'Login'
        }
    },
    {
        path: '/register',
        component: Register
    },
    {
        path: '/forgot_password',
        name: 'forgot_password',
        component: ForgotPassword,
        meta: {
            title: 'Forgot Password'
        }
    },
    {
        path: '/reset_password',
        component: ResetPassword
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: logout
    },

    {
        path: '/permission/permission_create',
        name: 'permission_create',
        beforeEnter: guardMyroute,
        component: PermissionCreate,
        meta: {
            title: 'Create Permission'
        }
    },

    {
        path: '/permission/all_permission',
        name: 'all_permission',
        beforeEnter: guardMyroute,
        component: PermissionList,
        meta: {
            title: 'Permission List'
        }
    },
    {
        path: '/permission/permission_update/:id',
        name: 'permission_update',
        beforeEnter: guardMyroute,
        component: PermissionUpdate,
        params: true,
        meta: {
            title: 'Permission List'
        }
    },
    {
        path: '/admin/admin_create',
        name: 'admin_create',
        beforeEnter: guardMyroute,
        component: AdminCreate,
        meta: {
            title: 'New Admin Entry'
        }
    },
    {
        path: '/admin/pin_create',
        name: 'pin_create',
        beforeEnter: guardMyroute,
        component: PinCreate,
        meta: {
            title: 'Pin Entry'
        }
    },
    {
        path: '/admin/admin_update/:uuid',
        name: 'admin_update',
        beforeEnter: guardMyroute,
        component: AdminUpdate,
        params: true,
        meta: {
            title: 'Admin Update'
        }
    },

    {
        path: '/admin/all_admin',
        name: 'all_admin',
        beforeEnter: guardMyroute,
        component: AdminList,
        meta: {
            title: 'Admin List'
        }
    },
    {
        path: '/admin/pin_list',
        name: 'pin_list',
        beforeEnter: guardMyroute,
        component: PinList,
        meta: {
            title: 'Pin List'
        }
    },

    {
        path: '/admin/pin_update/:id',
        name: 'pin_update',
        beforeEnter: guardMyroute,
        component: PinUpdate,
        params: true,
        meta: {
            title: 'Pin Update'
        }
    },
    {
        path: '/role/role_create',
        name: 'role_create',
        beforeEnter: guardMyroute,
        component: RoleCreate,
        meta: {
            title: 'New Role Entry'
        }
    },
    {
        path: '/role/all_role',
        name: 'all_role',
        beforeEnter: guardMyroute,
        component: RoleList,
        meta: {
            title: 'Role List'
        }
    },
    {
        path: '/role/role_update/:id',
        name: 'role_update',
        beforeEnter: guardMyroute,
        component: RoleUpdate,
        params: true,
        meta: {
            title: 'Role List'
        }
    },
        {
            path: '/role/role_user',
            name: 'role_user',
            beforeEnter: guardMyroute,
            component: RoleUser,
            params: true,
            meta: {
                title: 'User Role List'
            }
        },
    {
        path: '/airlines/airline_create',
        name: 'airline_create',
        beforeEnter: guardMyroute,
        component: AirlineCreate,
        meta: {
            title: 'New Airline Entry'
        }
    },
    {
        path: '/airlines/all_airlines',
        name: 'all_airlines',
        beforeEnter: guardMyroute,
        component: AirlineList,
        meta: {
            title: 'Airlines List'
        }
    },
    {
        path: '/airlines/airline_update/:id',
        name: 'airline_update',
        beforeEnter: guardMyroute,
        component: AirlineUpdate,
        params: true,
        meta: {
            title: 'Airline Update'
        }
    },
    {
        path: '/airlines/block_create',
        name: 'block_create',
        beforeEnter: guardMyroute,
        component: BlockEntry,
        meta: {
            title: 'Airline Block Entry'
        }
    },
    {
        path: '/airlines/block_list',
        name: 'block_list',
        beforeEnter: guardMyroute,
        component: BlockList,
        meta: {
            title: 'Airlines Block List'
        }
    },
    {
        path: '/airlines/block_update/:uuid',
        name: 'block_update',
        beforeEnter: guardMyroute,
        component: BlockUpdate,
        params: true,
        meta: {
            title: 'Airline Block Update'
        }
    },
    {
        path: '/airlines/route_create',
        name: 'route_create',
        beforeEnter: guardMyroute,
        component: RouteEntry,
        meta: {
            title: 'Airline Route Entry'
        }
    },
    {
        path: '/airlines/route_list',
        name: 'route_list',
        beforeEnter: guardMyroute,
        component: RouteList,
        meta: {
            title: 'Airlines Route List'
        }
    },
    {
        path: '/airlines/routing_update/:uuid',
        name: 'routing_update',
        beforeEnter: guardMyroute,
        component: RouteUpdate,
        params: true,
        meta: {
            title: 'Airline Route Update'
        }
    },
    {
        path: '/agent/agent_create',
        name: 'agent_create',
        beforeEnter: guardMyroute,
        component: AgentCreate,
        meta: {
            title: 'New Agent Entry'
        }
    },
    {
        path: '/agent/approved_agent_list',
        name: 'approved_agent_list',
        beforeEnter: guardMyroute,
        component: AgentList,
        meta: {
            title: 'Agent List'
        }
    },
        {
            path: '/agent/unverified_agent_list',
            name: 'unverified_agent_list',
            beforeEnter: guardMyroute,
            component: UnverifiedAgentList,
            meta: {
                title: 'Unverified Agent List'
            }
        },
    {
        path: '/agent/rejected_agent_list',
        name: 'rejected_agent_list',
        beforeEnter: guardMyroute,
        component: RejAgentList,
        meta: {
            title: 'Rejected Agent List'
        }
    },
    {
        path: '/agent/agent_update/:type/:uuid',
        name: 'agent_update',
        beforeEnter: guardMyroute,
        component: AgentUpdate,
        params: true,
        meta: {
            title: 'Agent Update'
        }
    },
    {
        path: '/agent/agent_list',
        name: 'agent_list',
        beforeEnter: guardMyroute,
        component: AgentApproval,
        params: true,
        meta: {
            title: 'Agent Approval'
        }
    },
        {
            path: '/agent/white_label_assign',
            name: 'white_label_assign',
            beforeEnter: guardMyroute,
            component: WhiteLabelAgentAssign,
            params: true,
            meta: {
                title: 'While Label Assign'
            }
        },
        {
            path: '/agent/white_label_agent_list',
            name: 'white_label_agent_list',
            beforeEnter: guardMyroute,
            component: WhiteLabelAgentList,
            params: true,
            meta: {
                title: 'While Label Agent'
            }
        },
        {
            path: '/agent/role_assign_b2b',
            name: 'role_assign_b2b',
            beforeEnter: guardMyroute,
            component: RoleAssignB2b,
            meta: {
                title: 'Role Assign To User'
            }
        },
        {
            path: '/agent/sub_agent_create',
            name: 'sub_agent_create',
            beforeEnter: guardMyroute,
            component: SubAgentCreate,
            meta: {
                title: 'Sub Agent Entry'
            }
        },
        {
            path: '/agent/sub_agent_list',
            name: 'sub_agent_list',
            beforeEnter: guardMyroute,
            component: SubAgentList,
            meta: {
                title: 'Sub Agent List'
            }
        },
        {
            path: '/agent/agent_user_details/:id',
            name: 'agent_user_details',
            beforeEnter: guardMyroute,
            component: AgentUserDetails,
            meta: {
                title: 'Agent User Details'
            }
        },
    {
        path: '/markup_commission/markup_commission_entry',
        name: 'markup_commission_entry',
        beforeEnter: guardMyroute,
        component: MarkupCreate,
        meta: {
            title: 'Markup Commission Entry'
        }
    },

    {
        path: '/markup_commission/markup_commission_list',
        name: 'markup_commission_list',
        beforeEnter: guardMyroute,
        component: MarkupComList,
        meta: {
            title: 'Markup Commission List'
        }
    },
    {
        path: '/markup_commission/markup_update/:uuid',
        name: 'markup_update',
        beforeEnter: guardMyroute,
        component: MarkupComUpdate,
        params: true,
        meta: {
            title: 'Markup Commission List'
        }
    },
    {
        path: '/api_vendors/api_vendor_entry',
        name: 'api_vendor_entry',
        beforeEnter: guardMyroute,
        component: APIvendorEntry,
        meta: {
            title: 'API Vendor Entry'
        }
    },
    {
        path: '/api_vendors/api_vendor_list',
        name: 'api_vendor_list',
        beforeEnter: guardMyroute,
        component: APIVendorList,
        meta: {
            title: 'API Vendor List'
        }
    },
    {
        path: '/api_vendors/vendor_update/:uuid',
        name: 'vendor_update',
        beforeEnter: guardMyroute,
        component: APIVendorUpdate,
        params: true,
        meta: {
            title: 'API Vendor update'
        }
    },
    {
        path: '/sales_manager/sales_manager_entry',
        name: 'sales_manager_entry',
        beforeEnter: guardMyroute,
        component: SalesManagerEntry,
        meta: {
            title: 'Sales Manager Entry'
        }
    },
    {
        path: '/sales_manager/sales_manager_list',
        name: 'sales_manager_list',
        beforeEnter: guardMyroute,
        component: SalesManagerList,
        meta: {
            title: 'Sales Manager List'
        }
    },
    {
        path: '/sales_manager/sales_manager_update/:id',
        name: 'sales_manager_update',
        beforeEnter: guardMyroute,
        component: SalesManagerUpdate,
        params: true,
        meta: {
            title: 'Sales Manager update'
        }
    },
        {
            path: '/sales_manager/sales_manager_agent',
            name: 'list_sales_manager_agent',
            beforeEnter: guardMyroute,
            component: SalesManagerAgent,
            meta: {
                title: 'Sales Manager Agent'
            }
        },

    {
        path: '/admin/role_assign',
        name: 'role_assign',
        beforeEnter: guardMyroute,
        component: RoleAssign,
        meta: {
            title: 'Role Assign To User'
        }
    },
    {
        path: '/admin/permission_assign',
        name: 'permission_assign',
        beforeEnter: guardMyroute,
        component: PermissionAssign,
        meta: {
            title: 'Permission Assign To Role'
        }
    },
    {
        path: '/activities/activity_entry',
        name: 'activity_entry',
        beforeEnter: guardMyroute,
        component: ActivityEntry,
        meta: {
            title: 'Activity Entry'
        }
    },
    {
        path: '/activities/activities_list',
        name: 'activities_list',
        beforeEnter: guardMyroute,
        component: ActivityList,
        meta: {
            title: 'Activities List'
        }
    },
    {
        path: '/activities/activities_update/:id',
        name: 'activities_update',
        beforeEnter: guardMyroute,
        component: ActivityUpdate,
        params: true,
        meta: {
            title: 'Activities Update'
        }
    },
    {
        path: '/deposit/deposit_list',
        name: 'deposit_list',
        beforeEnter: guardMyroute,
        component: DepositList,
        meta: {
            title: 'Deposit List'
        }
    },
        {
            path: '/deposit/deposit_list/:status',
            name: 'deposit_list',
            beforeEnter: guardMyroute,
            component: DepositList,
            meta: {
                title: 'Deposit List'
            }
        },
        {
            path: '/deposit/deposit_balance',
            name: 'deposit_add_balance',
            beforeEnter: guardMyroute,
            component: DepositBalance,
            meta: {
                title: 'Deposit Add'
            }
        },
        {
            path: '/deposit/deduct_balance',
            name: 'deposit_deduct_balance',
            beforeEnter: guardMyroute,
            component: DeductBalance,
            meta: {
                title: 'Deposit Deduct'
            }
        },
        {
            path: '/deposit/loan_balance',
            name: 'deposit_loan_balance',
            beforeEnter: guardMyroute,
            component: LoanBalance,
            meta: {
                title: 'Loan Balance'
            }
        },
    {
        path: '/ledger/ledger_list',
        name: 'ledger_list',
        beforeEnter: guardMyroute,
        component: LedegerList,
        meta: {
            title: 'Transactions List'
        }
    },
        {
            path: '/ledger/ledger_list/:id',
            name: 'ledger_list',
            beforeEnter: guardMyroute,
            component: LedegerList,
            meta: {
                title: 'Transactions List'
            }
        },
    {
        path: '/booking/list',
        name: 'flight_booking_list',
        beforeEnter: guardMyroute,
        component: FlightBookingList,
        meta: {
            title: 'Booking List'
        }
    },
        {
            path: '/booking/list/:status',
            name: 'flight_booking_list',
            beforeEnter: guardMyroute,
            component: FlightBookingList,
            meta: {
                title: 'Booking List'
            }
        },
        {
            path: '/e_ticket/e_ticket_list',
            name: 'flight_ticket_list',
            beforeEnter: guardMyroute,
            component: FlightTicketList,
            meta: {
                title: 'Ticket List'
            }
        },
        {
            path: '/ticket/update/:searchReferenceKey',
            name: 'ticket_update',
            beforeEnter: guardMyroute,
            component: FlightTicketUpdate,
            params: true,
            meta: {
                title: 'Ticket Update'
            }
        },
        {
            path: '/booking/invoice/:id',
            name: 'booking_ticket_invoice',
            beforeEnter: guardMyroute,
            component: FlightTicketInvoice,
            meta: {
                title: 'Ticket Invoice'
            }
        },
        {
            path: '/booking/details/:id',
            name: 'booking_details',
            beforeEnter: guardMyroute,
            component: FlightBookingDetails,
            meta: {
                title: 'Booking Details'
            }
        },
        {
            path: '/booking/ticket/:id',
            name: 'booking_ticket',
            beforeEnter: guardMyroute,
            component: FlightBookingTicket,
            meta: {
                title: 'Ticket Details'
            }
        },
    {
        path: '/reports/flight_sales_reports',
        name: 'flight_sales_reports',
        beforeEnter: guardMyroute,
        component: FlightSalesReport,
        meta: {
            title: 'Sales Report'
        }
    },
        {
            path: '/reports/manager_booking_reports',
            name: 'manager_booking_reports',
            beforeEnter: guardMyroute,
            component: ManagerBookingReport,
            meta: {
                title: 'Manager Booking Report'
            }
        },
        {
            path: '/reports/user_search_book_ratio',
            name: 'user_search_book_ratio',
            beforeEnter: guardMyroute,
            component: SearchBookRatioUser,
            meta: {
                title: 'Search Book Ratio'
            }
        },
        {
            path: '/reports/manager_search_book_ratio',
            name: 'manager_search_book_ratio',
            beforeEnter: guardMyroute,
            component: SearchBookRatioManager,
            meta: {
                title: 'Search Book Ratio'
            }
        },
        {
            path: '/flight_search_log/log_list',
            name: 'flight_search_log_list',
            beforeEnter: guardMyroute,
            component: FlightSearchLog,
            meta: {
                title: 'Flight Search Logs'
            }
        },
        {
            path: '/support_ticket/subject_list',
            name: 'support_ticket_subject_list',
            beforeEnter: guardMyroute,
            component: SupportTicketSubjectList,
            meta: {
                title: 'Support Ticket Subjects'
            }
        },
        {
            path: '/support_ticket/ticket_list',
            name: 'support_ticket_list',
            beforeEnter: guardMyroute,
            component: SupportTicketList,
            meta: {
                title: 'Support Tickets'
            }
        },
        {
            path: '/support_ticket/history/:id',
            name: 'support_ticket_history',
            beforeEnter: guardMyroute,
            component: SupportTicketHistory,
            meta: {
                title: 'Support Ticket Messages'
            }
        },
        {
            path: '/support_ticket/create_ticket',
            name: 'support_ticket_create',
            beforeEnter: guardMyroute,
            component: CreateSupportTicket,
            meta: {
                title: 'Support Ticket Create'
            }
        },
        {
            path: '/support_ticket/create_subject',
            name: 'support_ticket_subject_create',
            beforeEnter: guardMyroute,
            component: CreateSupportTicketSubject,
            meta: {
                title: 'Support Ticket Subject Create'
            }
        },
        {
            path: '/support_ticket/update_subject/:id',
            name: 'support_ticket_subject_update',
            beforeEnter: guardMyroute,
            component: UpdateSupportTicketSubject,
            meta: {
                title: 'Support Ticket Subject Create'
            }
        },
        {
            path: '/b2c_user/b2c_user_list',
            name: 'b2c_user_list',
            beforeEnter: guardMyroute,
            component: B2cUserList,
            meta: {
                title: 'B2c User List'
            }
        },
        {
            path: '/b2c_user/b2c_user_show/:id',
            name: 'b2c_user_show',
            beforeEnter: guardMyroute,
            component: B2cUserShow,
            meta: {
                title: 'B2c User show'
            }
        },
        {
            path: '/b2c_user/b2c_user_update/:id',
            name: 'b2c_user_update',
            beforeEnter: guardMyroute,
            component: B2cUserUpdate,
            meta: {
                title: 'B2c User Update'
            }
        },
        {
            path: '/b2c_user/role_assign_b2c',
            name: 'b2c_role_assign',
            beforeEnter: guardMyroute,
            component: B2cUserRole,
            meta: {
                title: 'B2c User Role Assign'
            }
        },
        {
            path: '/b2c_user/b2c_user_role_list',
            name: 'b2c_user_role_list',
            beforeEnter: guardMyroute,
            component: B2cUserRoleList,
            meta: {
                title: 'B2c User Role List'
            }
        },
        {
            path: '/hotel_markup_commission/hotel_markup_commission_entry',
            name: 'hotel_markup_commission_entry',
            beforeEnter: guardMyroute,
            component: HotelMarkupCreate,
            meta: {
                title: 'Hotel Markup Commission Entry'
            }
        },
        {
            path: '/hotel_markup_commission/hotel_markup_commission_list',
            name: 'hotel_markup_commission_list',
            beforeEnter: guardMyroute,
            component: HotelMarkupList,
            meta: {
                title: 'Hotel Markup Commission List'
            }
        },
        {
            path: '/hotel_markup_commission/hotel_markup_commission_update/:uuid',
            name: 'hotel_markup_commission_update',
            beforeEnter: guardMyroute,
            component: HotelMarkupUpdate,
            params: true,
            meta: {
                title: 'Hotel Markup Commission Update'
            }
        },
        {
            path: '/hotel/hotel_route_create',
            name: 'hotel_route_create',
            beforeEnter: guardMyroute,
            component: HotelRouteEntry,
            meta: {
                title: 'Hotel Route Entry'
            }
        },
        {
            path: '/hotel/hotel_route_list',
            name: 'hotel_route_list',
            beforeEnter: guardMyroute,
            component: HotelRouteList,
            meta: {
                title: 'Hotel Route List'
            }
        },
        {
            path: '/hotel/hotel_route_update/:uuid',
            name: 'hotel_route_update',
            beforeEnter: guardMyroute,
            component: HotelRouteUpdate,
            meta: {
                title: 'Hotel Route Update'
            }
        },
        {
            path: '/hotel/hotel_block_create',
            name: 'hotel_block_create',
            beforeEnter: guardMyroute,
            component: HotelBlockEntry,
            meta: {
                title: 'Hotel Block Entry'
            }
        },
        {
            path: '/hotel/hotel_block_list',
            name: 'hotel_block_list',
            beforeEnter: guardMyroute,
            component: HotelBlockList,
            meta: {
                title: 'Hotel Block List'
            }
        },
        {
            path: '/hotel/hotel_block_update/:uuid',
            name: 'hotel_block_update',
            beforeEnter: guardMyroute,
            component: HotelBlockUpdate,
            params: true,
            meta: {
                title: 'Hotel Block Update'
            }
        },
        {
            path: '/booking/hotel/list',
            name: 'hotel_booking_list',
            beforeEnter: guardMyroute,
            component: HotelBookingList,
            meta: {
                title: 'Hotel Booking List'
            }
        },
        {
            path: '/reports/hotel_sales_reports',
            name: 'hotel_sales_reports',
            beforeEnter: guardMyroute,
            component: HotelSalesReport,
            meta: {
                title: 'Hotel Sales Report'
            }
        },
        {
            path: '/booking/partial_payment_list',
            name: 'booking_partial_payment_list',
            beforeEnter: guardMyroute,
            component: PartialPaymentList,
            meta: {
                title: 'Partial Payment List'
            }
        },
        {
            path: '/booking/partial_payment_list/:status',
            name: 'booking_partial_payment_list',
            beforeEnter: guardMyroute,
            component: PartialPaymentList,
            meta: {
                title: 'Partial Payment List'
            }
        },
        {
            path: '/booking/flight/update/:id',
            name: 'flight_booking_update',
            beforeEnter: guardMyroute,
            component: FlightBookingUpdate,
            params: true,
            meta: {
                title: 'Flight Booking Update'
            }
        },
        {
            path: '/booking/hotel/update/:id',
            name: 'hotel_booking_update',
            beforeEnter: guardMyroute,
            component: HotelBookingUpdate,
            meta: {
                title: 'Hotel Booking Update'
            }
        },
        {
            path: '/booking/flight/create',
            name: 'flight_booking_create',
            beforeEnter: guardMyroute,
            component: FlightBookingCreate,
            params: true,
            meta: {
                title: 'Flight Booking Create'
            }
        },
        {
            path: '/setting/notification_mail_create',
            name: 'notification_mail_create',
            beforeEnter: guardMyroute,
            component: NotificationMailEntry,
            meta: {
                title: 'Notification Mail Entry'
            }
        },
        {
            path: '/setting/notification_mail_list',
            name: 'notification_mail_list',
            beforeEnter: guardMyroute,
            component: NotificationMailList,
            meta: {
                title: 'Notification Mail List'
            }
        },
        {
            path: '/setting/notification_mail_update/:id',
            name: 'notification_mail_update',
            beforeEnter: guardMyroute,
            component: NotificationMailUpdate,
            params: true,
            meta: {
                title: 'Notification Mail Update'
            }
        },
        {
            path: '/airlines/airport_create',
            name: 'airport_create',
            beforeEnter: guardMyroute,
            component: AirportEntry,
            meta: {
                title: 'Airport Entry'
            }
        },
        {
            path: '/airlines/airport_list',
            name: 'airport_list',
            beforeEnter: guardMyroute,
            component:AirportList,
            meta: {
                title: 'Airport List'
            }
        },
        {
            path: '/airlines/airport_update/:id',
            name: 'airport_update',
            beforeEnter: guardMyroute,
            component: AirportUpdate,
            params: true,
            meta: {
                title: 'Airport Update'
            }
        },
        {
            path: '/transactions/transaction_histories_list',
            name: 'transaction_histories',
            beforeEnter: guardMyroute,
            component: TransactionHistories,
            params: true,
            meta: {
                title: 'Transaction Histories'
            }
        },
        {
            path: '/agent/admin_agent_details/:id',
            name: 'admin_agent_details',
            beforeEnter: guardMyroute,
            component: AdminAgentDetails,
            meta: {
                title: 'Agent User Details'
            }
        },
    ],
});

routes.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
})

export default routes;
